"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/js/typography/letterSpacing.ts
var letterSpacing = {
  letterSpacing0: 0,
  letterSpacing1: 0.25
};



exports.letterSpacing = letterSpacing;
//# sourceMappingURL=chunk-SER5UWJS.js.map